// Action Types
export const ADD_ACCESS_CONTROL_DATA = 'ADD_ACCESS_CONTROL_DATA';
export const FETCH_ACCESS_CONTROL = 'FETCH_ACCESS_CONTROL';
export const UPDATE_ACCESS_CONTROL = 'UPDATE_ACCESS_CONTROL';
export const SET_LOADING = 'SET_LOADING';
export const UPDATE_CHECKED_ITEMS = 'UPDATE_CHECKED_ITEMS';


export const addAccessControlData = (data) => ({
  type: 'ADD_ACCESS_CONTROL_DATA',
  payload: data,
});

export const updateCheckedItems = (sectionKey, updatedItems) => ({
  type: 'UPDATE_ACCESS_CONTROL',
  payload: { sectionKey, updatedItems },
});

